import { ReactElement } from 'react';
import { PowerAssetChip } from '../PowerAssetChip';
import * as Icons from '../icons';
import { PowerInput, PowerInputStatus, PowerInputType, isPowerInputActive } from './types';

const TYPE_ICONS: Record<PowerInputType, ReactElement> = {
  [PowerInputType.GRID]: <Icons.ElectricBolt />,
  [PowerInputType.GENERATOR]: <Icons.OilBarrel />,
  [PowerInputType.SOLAR]: <Icons.SolarPowerFilled />,
  [PowerInputType.LOAD]: <Icons.Domain />,
  [PowerInputType.ENERGY_METER]: <Icons.ElectricMeter />,
};

const STATUS_ICONS: Record<Exclude<PowerInputStatus, PowerInputStatus.UNKNOWN>, ReactElement> = {
  [PowerInputStatus.ACTIVE]: <Icons.CheckCircle fontSize="small" sx={{ color: 'success.main' }} />,
  [PowerInputStatus.BUSY]: <Icons.Autorenew fontSize="small" />,
  [PowerInputStatus.ERROR]: <Icons.ErrorOutline fontSize="small" sx={{ color: 'error.main' }} />,
  [PowerInputStatus.IDLE]: <Icons.Bedtime fontSize="small" />,
};

export function PowerInputChip({ name, type, status = PowerInputStatus.UNKNOWN, details = [] }: PowerInput) {
  const statusColor = isPowerInputActive(status) ? 'success.main' : 'grey.400';

  return (
    <PowerAssetChip
      name={name}
      icon={TYPE_ICONS[type]}
      statusIcon={status !== PowerInputStatus.UNKNOWN ? STATUS_ICONS[status] : undefined}
      statusColor={statusColor}
      details={details}
      testId="power-input-chip"
    />
  );
}
